import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../components/layout/SimpleHeader';
import { RootState } from '../store/rootReducer';
import Branch from '../components/dashboard/Branch';
import HeadOffice from '../components/dashboard/HeadOffice';

const Dashboard = () => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const navbar = document.querySelector('nav.main-header');
    if (navbar?.classList.value.includes('d-none')) {
      // alert('오류가 발생했습니다.');
      // window.close();
    }
  }, []);

  return (
    <div className={auth.hqYn === 'Y' ? "content": "content scrollbar"}>
      <SimpleHeader parentMenu="Home" currentMenu={t('class.dashboard.title1')} onlyTitle={true} />

      <div>
        {auth.hqYn === 'Y' ? <HeadOffice /> : <Branch />}
      </div>
    </div>
  );
};

export default Dashboard;
